import type { TemplateOnlyComponent as TOC } from '@ember/component/template-only';
import type { HotelDetailsModel } from 'lumen/routes/hotel/settings/my-hotel/hotel-details';

import CardAddress from './card-address';
import CardBusinessProfile from './card-business-profile';

interface SettingsMyHotelFormHotelDetailsSignature {
  Args: {
    model: HotelDetailsModel;
  };
}

const SettingsMyHotelFormHotelDetails = <template>
  <div class="flex flex-col gap-600" data-test-id="form-hotel-details">
    <CardBusinessProfile
      @isLoading={{@model.requestProfileTask.isRunning}}
      @profile={{@model.requestProfileTask.last.value}}
    />
    <CardAddress
      @isLoading={{@model.requestProfileTask.isRunning}}
      @profile={{@model.requestProfileTask.last.value}}
    />
  </div>
</template> satisfies TOC<SettingsMyHotelFormHotelDetailsSignature>;

export default SettingsMyHotelFormHotelDetails;
